<template>
  <Breadcrumb separator=">" v-if="matched.length>1&&showList.indexOf(path)>-1">
    <template v-for="(v,i) in matched">
      <BreadcrumbItem v-if="i==matched.length-1" :key="i">{{title[v.path]}}</BreadcrumbItem>
      <BreadcrumbItem v-else :to="v.path" :key="i">{{title[v.path]}}</BreadcrumbItem>
    </template>
  </Breadcrumb>
</template>
<script>
/* 面包屑 */
export default {
  data() {
    return {
      // 路由路径对应名称
      title: {

        "/assets": this.$t('nav.w8'),
        "/assets/recharge": this.$t('nav.w9'),
        "/assets/withdraw": this.$t('nav.w10'),
        "/assets/creditCycle": this.$t('nav.w11'),
        "/assets/moneyRecord": this.$t('nav.w12'),
        "/assets/domainManage": this.$t('nav.w13'),
        "/assets/domainManage/batchPledge": this.$t('nav.w14'),
        "/assets/domainManage/batchRemove": this.$t('nav.w15'),
        "/assets/registrarManage": this.$t('nav.w16'),

        "/assets/batchRemove": this.$t('nav.w17'),
        "/assets/batchPledge": this.$t('nav.w18'),
        "/assets/applyCredit": this.$t('nav.w19'),


        '/security':this.$t('nav.w20'),
        '/security/bankCard':this.$t('nav.w21'),

        '/order':this.$t('nav.w22'),
        '/order/investOrder':this.$t('nav.w23'),
        '/order/loanOrder':this.$t('nav.w24'),

        '/autobid': this.$t('nav.w25'),
        '/autobid/createbid': this.$t('nav.w26'),
        '/autobid/setbid': this.$t('nav.w27'),

      },
      // 显示面包屑的路由列表
      showList:[

        '/assets/recharge',
        '/assets/withdraw',
        '/assets/creditCycle',
        '/assets/moneyRecord',
        '/assets/domainManage',
        '/assets/domainManage/batchPledge',
        '/assets/domainManage/batchRemove',
        '/assets/registrarManage',

        '/assets/batchRemove',
        '/assets/batchPledge',
        '/assets/applyCredit',


        '/security/bankCard',
        
        '/order/investOrder',
        '/order/loanOrder',

        '/autobid/createbid',
        '/autobid/setbid'
      ]
    };
  },
  computed: {
    matched() {
      return this.$route.matched;
    },
    path(){
      return this.$route.path
    }
  }
};
</script>
<style lang="less" scoped>
</style>
